import { render, staticRenderFns } from "./PostAddMedia.vue?vue&type=template&id=08290cf4&scoped=true&"
import script from "./PostAddMedia.vue?vue&type=script&lang=js&"
export * from "./PostAddMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08290cf4",
  null
  
)

export default component.exports